import { useAppSelector } from 'src/app/hooks'
import { selectEventType } from '../adjustmentSlice'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import scheduleApi from 'src/api/scheduleApi'
import AdjustmentSingleExternalStep2 from './adjustmentSingleExternalStep2'
import AdjustmentInternalAndMultiExternalStep2 from './adjustmentInternalAndMultiExternalStep2'
import { CONSTANTS } from 'src/config/constants'

interface Schedule {
    type: number;
    data: any;
}

const AdjustmentStep2 = () => {
    const { sid } = useParams()
    const eventType = useAppSelector(selectEventType)
    const [schedule, setSchedule] = useState<Schedule | null>(null)

    useEffect(() => {
        const fetchSchedule = async () => {
            if (!sid) return
            try {
                const response = await scheduleApi.getById({ id: sid })
                setSchedule(response.data)
            } catch (error) {
                console.error('Failed to fetch schedule:', error)
            }
        }

        fetchSchedule()
    }, [sid])

    const renderContent = () => {
        if (sid) {
            if (!schedule) return null // Loading state
            return [CONSTANTS.TYPE_ADJUSTMENT.INTERNAL, CONSTANTS.TYPE_ADJUSTMENT.MULTIPLE_EXTERNAL].includes(schedule.type)
                ? <AdjustmentInternalAndMultiExternalStep2 />
                : <AdjustmentSingleExternalStep2 />
        }

        if ([CONSTANTS.TYPE_ADJUSTMENT.INTERNAL, CONSTANTS.TYPE_ADJUSTMENT.MULTIPLE_EXTERNAL].includes(eventType)) {
            return <AdjustmentInternalAndMultiExternalStep2 />
        }
        if (eventType === CONSTANTS.TYPE_ADJUSTMENT.SINGLE_EXTERNAL) {
            return <AdjustmentSingleExternalStep2 />
        }

        return null
    }

    return <>{renderContent()}</>
}

export default AdjustmentStep2
